var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"base-image"},[_c('div',{staticClass:"base-image_box"},[_c('img',{ref:"image",staticClass:"base-image_image",attrs:{"src":_vm.image,"alt":_vm.alt,"id":(_vm.stepNumber + "-wfimage-" + (_vm.src.imageKey))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }